export default {
  repair: {
    id: 'menu_repair',
    defaultMessage: 'Repair',
  },
}
